import { downloadFileFromURL, getHourCycle } from '../../utils/utils';
import {
  CLEAR_FORM,
  CLEAR_TIMETABLE,
  CREATE_SPECIAL_EVENT,
  GET_DELIVERY_HOURS,
  GET_SPECIAL_EVENT_REASONS,
  SET_CLOSE_TO_ALL,
  SET_IS_LOADING,
  SET_OPEN_24HOURS_TO_ALL,
  SET_SELECTED_RANGE_DATE,
  SET_SELECTED_START_DATE,
  SET_SPECIAL_EVENT_DATA,
  SET_SPECIFIC_SPECIAL_EVENT_DATA,
  SHOW_HOLIDAYS,
  GET_MASS_UPLOAD_FILE,
  TOGGLE_12H_FORMAT,
  SET_12H_FORMAT,
  HEALTH_CHECK_MDS,
  GET_SINGLE_RESTAURANT_WEEK_HOURS,
  GET_SPECIAL_EVENT_DAY_BY_DAY,
  TOGGLE_OPERATION_HOURS_VIEW_MODE,
  SET_RECENTLY_EDITED_BASE_HOURS,
  CLEAR_RECENTLY_EDITED_BASE_HOURS,
} from './../action-types/new-operation-hours-types';
import type { RecentlyEditedBaseHours } from '../../components/OperationHoursViewTab/hooks/useServiceData';

export const times = [
  '',
  '00:00',
  '00:30',
  '01:00',
  '01:30',
  '02:00',
  '02:30',
  '03:00',
  '03:30',
  '04:00',
  '04:30',
  '05:00',
  '05:30',
  '06:00',
  '06:30',
  '07:00',
  '07:30',
  '08:00',
  '08:30',
  '09:00',
  '09:30',
  '10:00',
  '10:30',
  '11:00',
  '11:30',
  '12:00',
  '12:30',
  '13:00',
  '13:30',
  '14:00',
  '14:30',
  '15:00',
  '15:30',
  '16:00',
  '16:30',
  '17:00',
  '17:30',
  '18:00',
  '18:30',
  '19:00',
  '19:30',
  '20:00',
  '20:30',
  '21:00',
  '21:30',
  '22:00',
  '22:30',
  '23:00',
  '23:30',
  '',
  '23:59',
];

const specialEventTimes = [
  '18:00',
  '18:30',
  '19:00',
  '19:30',
  '20:00',
  '20:30',
  '21:00',
  '21:30',
  '22:00',
  '22:30',
  '23:00',
  '23:30',
];

const specialDrDtTimes = [
  '00:00',
  '00:30',
  '01:00',
  '01:30',
  '02:00',
  '02:30',
  '03:00',
  '03:30',
  '04:00',
  '04:30',
  '05:00',
  '05:30',
  '06:00',
  '06:30',
  '07:00',
  '07:30',
  '08:00',
  '08:30',
  '09:00',
  '09:30',
  '10:00',
  '10:30',
  '11:00',
  '11:30',
  '12:00',
];

const initialState = {
  isEditing: false,
  loading: false,
  availableTimes: times,
  specialEventTimes: [...specialEventTimes, ...times],
  specialDrDtTimes: [...times, ...specialDrDtTimes],
  showHolidays: true,
  selectedStartDate: null,
  selectedEndDate: null,
  specialEventReason: null,
  specialEventReasons: [],
  isMDSUpAndRunning: true,
  deliveryHours: [],
  open24Hours: false,
  closeToAll: false,
  is12HFormat: false,
  shouldSwitchToViewMode: false,
  recentlyEditedBaseHours: {} as RecentlyEditedBaseHours,

  //Base day
  breakfastTimeOpen: null,
  breakfastTimeClose: null,
  lunchTimeOpen: null,
  lunchTimeClose: null,
  snackTimeOpen: null,
  snackTimeClose: null,
  dinnerTimeOpen: null,
  dinnerTimeClose: null,
  lateNightTimeOpen: null,
  lateNightTimeClose: null,

  // Request Params
  id: 0,
  specialEventDateStart: null,
  specialEventDateEnd: null,

  specialEventArrival: null,
  specialEventDeparture: null,

  drTimeOpenMode: [],
  drTimeCloseMode: [],
  drIsOpened24HoursMode: [],
  drIsOpened24Hours: null,
  drIsClosed: null,
  drTimeOpen: null,
  drTimeClose: null,

  dtTimeOpenMode: [],
  dtTimeCloseMode: [],
  dtIsClosedMode: [],
  dtIsOpened24HoursMode: [],
  dtIsOpened24Hours: null,
  dtIsClosed: null,
  dtTimeOpen: null,
  dtTimeClose: null,

  digitalDtTimeOpenMode: [],
  digitalDtTimeCloseMode: [],
  digitalDtIsClosedMode: [],
  digitalDtIsOpened24HoursMode: [],
  digitalDtIsOpened24Hours: null,
  digitalDtIsClosed: null,
  digitalDtTimeOpen: null,
  digitalDtTimeClose: null,

  deliveryTimeOpenMode: [],
  deliveryTimeCloseMode: [],
  isCalculated: null,
  deliveryTimeOpen: null,
  deliveryTimeClose: null,

  curbsideTimeOpenMode: [],
  curbsideTimeCloseMode: [],
  curbsideTimeOpen: null,
  curbsideTimeClose: null,

  cateringTimeOpenMode: [],
  cateringTimeCloseMode: [],
  cateringTimeOpen: null,
  cateringTimeClose: null,
  cateringIsClosed: null,
  cateringIsClosedMode: [],
  dhIsClosed: null,
  dhIsClosedMode: [],
  curbsideIsClosed: null,
  curbsideIsClosedMode: [],

  baseArrival: null,
  baseDeparture: null,
  baseDrTimeOpen: null,
  baseDrTimeClose: null,
  baseDtTimeOpen: null,
  baseDtTimeClose: null,
  baseDigitalDtTimeOpen: null,
  baseDigitalDtTimeClose: null,
  baseDeliveryTimeOpen: null,
  baseDeliveryTimeClose: null,
  baseCurbsideTimeOpen: null,
  baseCurbsideTimeClose: null,
  baseCateringTimeOpen: null,
  baseCateringTimeClose: null,
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  switch (action.type) {
    case CLEAR_FORM:
      return {
        ...initialState,
        specialEventReasons: state.specialEventReasons,
        deliveryHours: state.deliveryHours,
        drTimeOpenMode: state.drTimeOpenMode,
        drTimeCloseMode: state.drTimeCloseMode,
        drIsOpened24HoursMode: state.drIsOpened24HoursMode,
        dtTimeOpenMode: state.dtTimeOpenMode,
        dtTimeCloseMode: state.dtTimeCloseMode,
        dtIsClosedMode: state.dtIsClosedMode,
        dtIsOpened24HoursMode: state.dtIsOpened24HoursMode,
        digitalDtTimeOpenMode: state.digitalDtTimeOpenMode,
        digitalDtTimeCloseMode: state.digitalDtTimeCloseMode,
        digitalDtIsClosedMode: state.digitalDtIsClosedMode,
        digitalDtIsOpened24HoursMode: state.digitalDtIsOpened24HoursMode,
        deliveryTimeOpenMode: state.deliveryTimeOpenMode,
        deliveryTimeCloseMode: state.deliveryTimeCloseMode,
        cateringIsClosedMode: state.cateringIsClosedMode,
        dhIsClosedMode: state.dhIsClosedMode,
        curbsideIsClosedMode: state.curbsideIsClosedMode,
        curbsideTimeOpenMode: state.curbsideTimeOpenMode,
        curbsideTimeCloseMode: state.curbsideTimeCloseMode,
        cateringTimeOpenMode: state.cateringTimeOpenMode,
        cateringTimeCloseMode: state.cateringTimeCloseMode,
        breakfastTimeOpen: state.breakfastTimeOpen,
        breakfastTimeClose: state.breakfastTimeClose,
        lunchTimeOpen: state.lunchTimeOpen,
        lunchTimeClose: state.lunchTimeClose,
        snackTimeOpen: state.snackTimeOpen,
        snackTimeClose: state.snackTimeClose,
        dinnerTimeOpen: state.dinnerTimeOpen,
        dinnerTimeClose: state.dinnerTimeClose,
        lateNightTimeOpen: state.lateNightTimeOpen,
        lateNightTimeClose: state.lateNightTimeClose,

        baseArrival: state.baseArrival,
        baseDeparture: state.baseDeparture,
        baseDrTimeOpen: state.baseDrTimeOpen,
        baseDrTimeClose: state.baseDrTimeClose,
        baseDtTimeOpen: state.baseDtTimeOpen,
        baseDtTimeClose: state.baseDtTimeClose,
        baseDigitalDtTimeOpen: state.baseDigitalDtTimeOpen,
        baseDigitalDtTimeClose: state.baseDigitalDtTimeClose,
        baseDeliveryTimeOpen: state.baseDeliveryTimeOpen,
        baseDeliveryTimeClose: state.baseDeliveryTimeClose,
        baseCurbsideTimeOpen: state.baseCurbsideTimeOpen,
        baseCurbsideTimeClose: state.baseCurbsideTimeClose,
        baseCateringTimeOpen: state.baseCateringTimeOpen,
        baseCateringTimeClose: state.baseCateringTimeClose,
        isEditing: false,
        is12HFormat: state.is12HFormat,
        isMDSUpAndRunning: state.isMDSUpAndRunning,
      };
    case CLEAR_TIMETABLE:
      return {
        ...state,
        id: 0,
        open24Hours: false,
        closeToAll: false,
        specialEventArrival: null,
        specialEventDeparture: null,
        specialEventDateStart: null,
        specialEventDateEnd: null,
        drIsOpened24Hours: null,
        drIsClosed: null,
        drTimeOpen: null,
        drTimeClose: null,
        dtIsOpened24Hours: null,
        dtIsClosed: null,
        dtTimeOpen: null,
        dtTimeClose: null,
        digitalDtIsOpened24Hours: null,
        digitalDtIsClosed: null,
        digitalDtTimeOpen: null,
        digitalDtTimeClose: null,
        isCalculated: null,
        deliveryTimeOpen: null,
        deliveryTimeClose: null,
        curbsideTimeOpen: null,
        curbsideTimeClose: null,
        cateringTimeOpen: null,
        cateringTimeClose: null,
        cateringIsClosed: null,
        dhIsClosed: null,
        curbsideIsClosed: null,
        baseArrival: null,
        baseDeparture: null,
        baseDrTimeOpen: null,
        baseDrTimeClose: null,
        baseDtTimeOpen: null,
        baseDtTimeClose: null,
        baseDigitalDtTimeOpen: null,
        baseDigitalDtTimeClose: null,
        baseDeliveryTimeOpen: null,
        baseDeliveryTimeClose: null,
        baseCurbsideTimeOpen: null,
        baseCurbsideTimeClose: null,
        baseCateringTimeOpen: null,
        baseCateringTimeClose: null,
        isEditing: false,
        is12HFormat: state.is12HFormat,
      };
    case SET_IS_LOADING:
      return {
        ...state,
      };
    case TOGGLE_12H_FORMAT:
      return {
        ...state,
        is12HFormat: !state.is12HFormat,
      };
    case SET_12H_FORMAT:
      return {
        ...state,
        is12HFormat: action.payload,
      };
    case GET_SPECIAL_EVENT_REASONS.REQUEST:
      return {
        ...state,
        specialEventReasons: [],
      };
    case GET_SPECIAL_EVENT_REASONS.SUCCESS:
      return {
        ...state,
        specialEventReasons: action.payload.data.reasons,
      };
    case GET_SPECIAL_EVENT_REASONS.REJECTED:
      return {
        ...state,
        error: action.payload,
      };
    case GET_SPECIAL_EVENT_DAY_BY_DAY.REQUEST:
      return {
        ...state,
        specialEventDayByDay: [],
      };
    case GET_SPECIAL_EVENT_DAY_BY_DAY.SUCCESS:
      return {
        ...state,
        specialEventDayByDay: action.payload.data,
      };
    case GET_SPECIAL_EVENT_DAY_BY_DAY.REJECTED:
      return {
        ...state,
        error: action.payload,
      };
    case HEALTH_CHECK_MDS.REQUEST:
      return {
        ...state,
        isMDSUpAndRunning: true,
      };
    case HEALTH_CHECK_MDS.SUCCESS:
      return {
        ...state,
        isMDSUpAndRunning: !!action?.payload?.data?.success,
      };
    case HEALTH_CHECK_MDS.REJECTED:
      return {
        ...state,
        isMDSUpAndRunning: false,
        error: action.payload,
      };
    case GET_DELIVERY_HOURS.REQUEST:
      return {
        ...state,
        deliveryHours: [],
      };
    case GET_MASS_UPLOAD_FILE.REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_MASS_UPLOAD_FILE.SUCCESS: {
      downloadFileFromURL(action.payload.data?.result?.url, 'Mass_Upload_File');
      return {
        ...state,
        loading: false,
      };
    }
    case GET_MASS_UPLOAD_FILE.REJECTED:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case GET_DELIVERY_HOURS.SUCCESS:
      return {
        ...state,
        deliveryHours: action.payload.data,
      };
    case GET_DELIVERY_HOURS.REJECTED:
      return {
        ...state,
        error: action.payload,
      };

    case SHOW_HOLIDAYS:
      return {
        ...state,
        showHolidays: action.payload,
      };
    case SET_SELECTED_START_DATE:
      return {
        ...state,
        selectedStartDate: action.payload,
      };
    case SET_SELECTED_RANGE_DATE:
      return {
        ...state,
        selectedStartDate: action.payload.selectedStartDate,
        selectedEndDate: action.payload.selectedEndDate,
      };
    case SET_SPECIAL_EVENT_DATA:
      return {
        ...state,
        isEditing: false,
        open24Hours:
          action.payload.drIsOpened24Hours === 'Y' &&
          action.payload.dtIsOpened24Hours === 'Y'
            ? true
            : false,
        closeToAll:
          action.payload.drIsClosed === 'Y' && action.payload.dtIsClosed === 'Y'
            ? true
            : false,
        id: action.payload.id ? action.payload.id : initialState.id,
        specialEventDateStart: action.payload.specialEventDateStart
          ? action.payload.specialEventDateStart
          : initialState.specialEventDateStart,
        specialEventDateEnd: action.payload.specialEventDateEnd
          ? action.payload.specialEventDateEnd
          : initialState.specialEventDateEnd,
        specialEventArrival: action.payload.arrivalTime
          ? action.payload.arrivalTime
          : initialState.specialEventArrival,
        specialEventDeparture: action.payload.departureTime
          ? action.payload.departureTime
          : initialState.specialEventDeparture,
        drTimeOpen: action.payload.drTimeOpen
          ? action.payload.drTimeOpen
          : initialState.drTimeOpen,
        drTimeClose: action.payload.drTimeClose
          ? action.payload.drTimeClose
          : initialState.drTimeClose,
        dtTimeOpen: action.payload.dtTimeOpen
          ? action.payload.dtTimeOpen
          : initialState.dtTimeOpen,
        dtTimeClose: action.payload.dtTimeClose
          ? action.payload.dtTimeClose
          : initialState.dtTimeClose,
        digitalDtTimeOpen: action.payload.digitalDtTimeOpen
          ? action.payload.digitalDtTimeOpen
          : initialState.digitalDtTimeOpen,
        digitalDtTimeClose: action.payload.digitalDtTimeClose
          ? action.payload.digitalDtTimeClose
          : initialState.digitalDtTimeClose,
        deliveryTimeOpen: action.payload.deliveryTimeOpen
          ? action.payload.deliveryTimeOpen
          : initialState.deliveryTimeOpen,
        deliveryTimeClose: action.payload.deliveryTimeClose
          ? action.payload.deliveryTimeClose
          : initialState.deliveryTimeClose,
        curbsideTimeOpen: action.payload.curbsideTimeOpen
          ? action.payload.curbsideTimeOpen
          : initialState.curbsideTimeOpen,
        curbsideTimeClose: action.payload.curbsideTimeClose
          ? action.payload.curbsideTimeClose
          : initialState.curbsideTimeClose,
        cateringTimeOpen: action.payload.cateringTimeOpen
          ? action.payload.cateringTimeOpen
          : initialState.cateringTimeOpen,
        cateringTimeClose: action.payload.cateringTimeClose
          ? action.payload.cateringTimeClose
          : initialState.cateringTimeClose,
        baseArrival: action.payload.baseArrival
          ? action.payload.baseArrival
          : initialState.baseArrival,
        baseDeparture: action.payload.baseDeparture
          ? action.payload.baseDeparture
          : initialState.baseDeparture,
        baseDrTimeOpen: action.payload.baseDrTimeOpen
          ? action.payload.baseDrTimeOpen
          : initialState.baseDrTimeOpen,
        baseDrTimeClose: action.payload.baseDrTimeClose
          ? action.payload.baseDrTimeClose
          : initialState.baseDrTimeClose,
        baseDtTimeOpen: action.payload.baseDtTimeOpen
          ? action.payload.baseDtTimeOpen
          : initialState.baseDtTimeOpen,
        baseDtTimeClose: action.payload.baseDtTimeClose
          ? action.payload.baseDtTimeClose
          : initialState.baseDtTimeClose,
        baseDigitalDtTimeOpen: action.payload.baseDigitalDtTimeOpen
          ? action.payload.baseDigitalDtTimeOpen
          : initialState.baseDigitalDtTimeOpen,
        baseDigitalDtTimeClose: action.payload.baseDigitalDtTimeClose
          ? action.payload.baseDigitalDtTimeClose
          : initialState.baseDigitalDtTimeClose,
        baseDeliveryTimeOpen: action.payload.baseDeliveryTimeOpen
          ? action.payload.baseDeliveryTimeOpen
          : initialState.baseDeliveryTimeOpen,
        baseDeliveryTimeClose: action.payload.baseDeliveryTimeClose
          ? action.payload.baseDeliveryTimeClose
          : initialState.baseDeliveryTimeClose,
        baseCurbsideTimeOpen: action.payload.baseCurbsideTimeOpen
          ? action.payload.baseCurbsideTimeOpen
          : initialState.baseCurbsideTimeOpen,
        baseCurbsideTimeClose: action.payload.baseCurbsideTimeClose
          ? action.payload.baseCurbsideTimeClose
          : initialState.baseCurbsideTimeClose,
        baseCateringTimeOpen: action.payload.baseCateringTimeOpen
          ? action.payload.baseCateringTimeOpen
          : initialState.baseCateringTimeOpen,
        baseCateringTimeClose: action.payload.baseCateringTimeClose
          ? action.payload.baseCateringTimeClose
          : initialState.baseCateringTimeClose,
        baseCateringIsClosed: action.payload.cateringIsClosed
          ? action.payload.cateringIsClosed
          : initialState.cateringIsClosed,
        baseCurbsideIsClosed: action.payload.curbsideIsClosed
          ? action.payload.curbsideIsClosed
          : initialState.curbsideIsClosed,
        baseDhIsClosed: action.payload.dhIsClosed
          ? action.payload.dhIsClosed
          : initialState.dhIsClosed,
        digitalDtIsOpened24Hours: action.payload.digitalDtIsOpened24Hours
          ? action.payload.digitalDtIsOpened24Hours
          : initialState.digitalDtIsOpened24Hours,
        drIsOpened24Hours: action.payload.drIsOpened24Hours
          ? action.payload.drIsOpened24Hours
          : initialState.drIsOpened24Hours,
        drIsClosed: action.payload.drIsClosed
          ? action.payload.drIsClosed
          : initialState.drIsClosed,
        dtIsOpened24Hours: action.payload.dtIsOpened24Hours
          ? action.payload.dtIsOpened24Hours
          : initialState.dtIsOpened24Hours,
        dtIsClosed: action.payload.dtIsClosed
          ? action.payload.dtIsClosed
          : initialState.dtIsClosed,
        digitalDtIsClosed: action.payload.digitalDtIsClosed
          ? action.payload.digitalDtIsClosed
          : initialState.digitalDtIsClosed,
        isCalculated: action.payload.isCalculated
          ? action.payload.isCalculated
          : initialState.isCalculated,
        drTimeOpenMode: action.payload.drTimeOpenMode
          ? action.payload.drTimeOpenMode
          : initialState.drTimeOpenMode,
        drTimeCloseMode: action.payload.drTimeCloseMode
          ? action.payload.drTimeCloseMode
          : initialState.drTimeCloseMode,
        drIsOpened24HoursMode: action.payload.drIsOpened24HoursMode
          ? action.payload.drIsOpened24HoursMode
          : initialState.drIsOpened24HoursMode,
        dtTimeOpenMode: action.payload.dtTimeOpenMode
          ? action.payload.dtTimeOpenMode
          : initialState.dtTimeOpenMode,
        dtTimeCloseMode: action.payload.dtTimeCloseMode
          ? action.payload.dtTimeCloseMode
          : initialState.dtTimeCloseMode,
        dtIsClosedMode: action.payload.dtIsClosedMode
          ? action.payload.dtIsClosedMode
          : initialState.dtIsClosedMode,
        dtIsOpened24HoursMode: action.payload.dtIsOpened24HoursMode
          ? action.payload.dtIsOpened24HoursMode
          : initialState.dtIsOpened24HoursMode,
        digitalDtTimeOpenMode: action.payload.digitalDtTimeOpenMode
          ? action.payload.digitalDtTimeOpenMode
          : initialState.digitalDtTimeOpenMode,
        digitalDtTimeCloseMode: action.payload.digitalDtTimeCloseMode
          ? action.payload.digitalDtTimeCloseMode
          : initialState.digitalDtTimeCloseMode,
        digitalDtIsClosedMode: action.payload.digitalDtIsClosedMode
          ? action.payload.digitalDtIsClosedMode
          : initialState.digitalDtIsClosedMode,
        digitalDtIsOpened24HoursMode: action.payload
          .digitalDtIsOpened24HoursMode
          ? action.payload.digitalDtIsOpened24HoursMode
          : initialState.digitalDtIsOpened24HoursMode,
        deliveryTimeOpenMode: action.payload.deliveryTimeOpenMode
          ? action.payload.deliveryTimeOpenMode
          : initialState.deliveryTimeOpenMode,
        deliveryTimeCloseMode: action.payload.deliveryTimeCloseMode
          ? action.payload.deliveryTimeCloseMode
          : initialState.deliveryTimeCloseMode,
        curbsideTimeOpenMode: action.payload.curbsideTimeOpenMode
          ? action.payload.curbsideTimeOpenMode
          : initialState.curbsideTimeOpenMode,
        curbsideTimeCloseMode: action.payload.curbsideTimeCloseMode
          ? action.payload.curbsideTimeCloseMode
          : initialState.curbsideTimeCloseMode,
        cateringTimeOpenMode: action.payload.cateringTimeOpenMode
          ? action.payload.cateringTimeOpenMode
          : initialState.cateringTimeOpenMode,
        cateringTimeCloseMode: action.payload.cateringTimeCloseMode
          ? action.payload.cateringTimeCloseMode
          : initialState.cateringTimeCloseMode,
        breakfastTimeOpen: action.payload.breakfastTimeOpen
          ? action.payload.breakfastTimeOpen
          : initialState.breakfastTimeOpen,
        breakfastTimeClose: action.payload.breakfastTimeClose
          ? action.payload.breakfastTimeClose
          : initialState.breakfastTimeClose,
        lunchTimeOpen: action.payload.lunchTimeOpen
          ? action.payload.lunchTimeOpen
          : initialState.lunchTimeOpen,
        lunchTimeClose: action.payload.lunchTimeClose
          ? action.payload.lunchTimeClose
          : initialState.lunchTimeClose,
        snackTimeOpen: action.payload.snackTimeOpen
          ? action.payload.snackTimeOpen
          : initialState.snackTimeOpen,
        snackTimeClose: action.payload.snackTimeClose
          ? action.payload.snackTimeClose
          : initialState.snackTimeClose,
        dinnerTimeOpen: action.payload.dinnerTimeOpen
          ? action.payload.dinnerTimeOpen
          : initialState.dinnerTimeOpen,
        dinnerTimeClose: action.payload.dinnerTimeClose
          ? action.payload.dinnerTimeClose
          : initialState.dinnerTimeClose,
        lateNightTimeOpen: action.payload.lateNightTimeOpen
          ? action.payload.lateNightTimeOpen
          : initialState.lateNightTimeOpen,
        lateNightTimeClose: action.payload.lateNightTimeClose
          ? action.payload.lateNightTimeClose
          : initialState.lateNightTimeClose,
        cateringIsClosed: action.payload.cateringIsClosed
          ? action.payload.cateringIsClosed
          : initialState.cateringIsClosed,
        dhIsClosed: action.payload.dhIsClosed
          ? action.payload.dhIsClosed
          : initialState.dhIsClosed,
        curbsideIsClosed: action.payload.curbsideIsClosed
          ? action.payload.curbsideIsClosed
          : initialState.curbsideIsClosed,
        cateringIsClosedMode: action.payload.cateringIsClosedMode
          ? action.payload.cateringIsClosedMode
          : initialState.cateringIsClosedMode,
        dhIsClosedMode: action.payload.dhIsClosedMode
          ? action.payload.dhIsClosedMode
          : initialState.dhIsClosedMode,
        curbsideIsClosedMode: action.payload.curbsideIsClosedMode
          ? action.payload.curbsideIsClosedMode
          : initialState.curbsideIsClosedMode,
      };
    case SET_SPECIFIC_SPECIAL_EVENT_DATA:
      return {
        ...state,
        isEditing: true,
        ...action.payload,
      };
    case SET_OPEN_24HOURS_TO_ALL:
      return {
        ...state,
        open24Hours: action.payload.open24Hours,
        closeToAll: action.payload.closeToAll,
        drIsOpened24Hours: action.payload.drIsOpened24Hours,
        drIsClosed: action.payload.drIsClosed,
        drTimeOpen: action.payload.drTimeOpen,
        drTimeClose: action.payload.drTimeClose,

        dtIsOpened24Hours: action.payload.dtIsOpened24Hours,
        dtIsClosed: action.payload.dtIsClosed,
        dtTimeOpen: action.payload.dtTimeOpen,
        dtTimeClose: action.payload.dtTimeClose,

        digitalDtIsOpened24Hours: action.payload.digitalDtIsOpened24Hours,
        digitalDtIsClosed: action.payload.digitalDtIsClosed,
        digitalDtTimeOpen: action.payload.digitalDtTimeOpen,
        digitalDtTimeClose: action.payload.digitalDtTimeClose,

        deliveryTimeOpen: action.payload.deliveryTimeOpen,
        deliveryTimeClose: action.payload.deliveryTimeClose,

        isEditing: true,
      };
    case SET_CLOSE_TO_ALL:
      return {
        ...state,
        open24Hours: action.payload.open24Hours,
        closeToAll: action.payload.closeToAll,
        drIsOpened24Hours: action.payload.drIsOpened24Hours,
        drIsClosed: action.payload.drIsClosed,
        drTimeOpen: action.payload.drTimeOpen,
        drTimeClose: action.payload.drTimeClose,

        dtIsOpened24Hours: action.payload.dtIsOpened24Hours,
        dtIsClosed: action.payload.dtIsClosed,
        dtTimeOpen: action.payload.dtTimeOpen,
        dtTimeClose: action.payload.dtTimeClose,

        digitalDtIsOpened24Hours: action.payload.digitalDtIsOpened24Hours,
        digitalDtIsClosed: action.payload.digitalDtIsClosed,
        digitalDtTimeOpen: action.payload.digitalDtTimeOpen,
        digitalDtTimeClose: action.payload.digitalDtTimeClose,

        deliveryTimeOpen: action.payload.deliveryTimeOpen,
        deliveryTimeClose: action.payload.deliveryTimeClose,
        cateringIsClosed: action.payload.cateringIsClosed,
        dhIsClosed: action.payload.dhIsClosed,
        curbsideIsClosed: action.payload.curbsideIsClosed,

        isEditing: true,
      };
    case CREATE_SPECIAL_EVENT.SUCCESS:
      return {
        ...state,
        specialEventReason: null,
        isEditing: false,
      };
    case GET_SINGLE_RESTAURANT_WEEK_HOURS.REQUEST:
      return {
        ...state,
        restaurantWeekHours: [],
      };
    case GET_SINGLE_RESTAURANT_WEEK_HOURS.SUCCESS:
      return {
        ...state,
        restaurantWeekHours: action.payload.data?.restaurants || {},
      };
    case GET_SINGLE_RESTAURANT_WEEK_HOURS.REJECTED:
      return {
        ...state,
        error: action.payload,
      };
    case TOGGLE_OPERATION_HOURS_VIEW_MODE:
      return {
        ...state,
        shouldSwitchToViewMode: action.payload,
      };
    case SET_RECENTLY_EDITED_BASE_HOURS:
      return {
        ...state,
        recentlyEditedBaseHours: action.payload,
      };
    case CLEAR_RECENTLY_EDITED_BASE_HOURS:
      return {
        ...state,
        recentlyEditedBaseHours: {},
      };
    default:
      return state;
  }
}
